import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import logo from "../images/logo-rafa-guru.png"; // Asegúrate de que la ruta sea correcta
import "../styles/IframeComponent.css"; // Importa el archivo de estilos

const IframeComponent = () => {
  const [url, setUrl] = useState("");
  const navigate = useNavigate();
  const iframeRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const tokenExpiration = localStorage.getItem("token_expiration");

    if (!token || !tokenExpiration) {
      console.log("No hay sesión activa. Redirigiendo a login...");
      navigate("/login");
      return;
    }

    const currentTime = new Date();
    const expirationTime = new Date(tokenExpiration);

    if (currentTime > expirationTime) {
      console.log("Token expirado. Redirigiendo a login...");
      localStorage.removeItem("token");
      localStorage.removeItem("token_expiration");
      navigate("/login");
      return;
    }

    const verifyToken = async () => {
      try {
        const response = await axios.post(
          "https://services.neuralactions.com/api/rafa_verify_token",
          { token }
        );

        if (response.data.isValid) {
          const na_url = "https://app.neuralactions.com";
          const portalID = "rafaGuru";
          const host = "app.rafa.guru";
          const formattedExpiration = expirationTime.toISOString().slice(0, 10);
          const iframeUrl = `${na_url}/public/quick-login/${token}/${formattedExpiration}?portal=${portalID}&portalUrl=${host}`;
          setUrl(iframeUrl);
        } else {
          console.log("Token inválido. Redirigiendo a login...");
          localStorage.removeItem("token");
          localStorage.removeItem("token_expiration");
          navigate("/login");
        }
      } catch (error) {
        console.error("Error al verificar el token:", error);
        localStorage.removeItem("token");
        localStorage.removeItem("token_expiration");
        navigate("/login");
      }
    };

    verifyToken();
  }, [navigate]);

  return (
    <div className="iframe-container">
      {url ? (
        <iframe
          ref={iframeRef}
          id="frame"
          src={url}
          title="NeuralActions"
          className="iframe-content"
        />
      ) : (
        <div className="loading-container">
          <img src={logo} alt="Cargando..." className="loading-logo" />
          <br></br>
          <br></br>
          <br></br>
          
          <p className="loading-text">Cargando...</p>
        </div>
      )}
    </div>
  );
};

export default IframeComponent;
